import React from 'react';
import useSeoForPage from '../hooks/useSeoForPage';

export default function ContactPage() {
  useSeoForPage('/kontakt');
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="text-3xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
        Kontakt
      </h1>
      <p className="text-slate-600 leading-relaxed mb-8">
        Wir sind ständig dabei, Domain-Preisvergleich.de zu testen und weiterzuentwickeln. Auch die Preise und
        Anbieterinformationen in unserer Datenbank werden ständig kontrolliert. Aber alles sehen wir nicht: Wenn Sie
        also einen Fehler auf unserer Seite finden oder einen falschen Preis entdecken, schreiben Sie uns – dann
        können wir den Fehler schnell beheben.
      </p>
      <p className="text-slate-600 leading-relaxed mb-8">
        Sie haben eine Idee, wie wir Domain-Preisvergleich noch besser machen können? Lassen Sie es uns wissen!
      </p>

      <div className="rounded-xl border border-slate-200 bg-white p-5">
        <h2 className="text-lg font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          So erreichen Sie uns
        </h2>
        <ul className="space-y-2 text-slate-600 text-[15px]">
          <li>
            <strong>E-Mail:</strong>{' '}
            <a href="mailto:kontakt@domain-preischeck.de" className="text-sky-600 hover:text-sky-700">
              kontakt@domain-preischeck.de
            </a>
          </li>
          <li>
            <strong>Anbieter (Provider):</strong> Informationen zur Listung und Pro-Partnerschaft finden Sie auf
            unserer Seite{' '}
            <a href="/fuer-provider" className="text-sky-600 hover:text-sky-700">Für Provider</a>.
          </li>
        </ul>
      </div>
    </div>
  );
}
